export { createAsyncThunk } from '@reduxjs/toolkit'

export const modelName = 'business'
export { default as apiFetch } from '../apiFetch'
